import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { ArrowLeft, Save } from "lucide-react";
import { toast } from "sonner";

export default function ExpedienteDetailPage() {
  const { id } = useParams();
  const nav = useNavigate();
  const [v, setV] = useState(null);
  const [clients, setClients] = useState([]);
  const [photos, setPhotos] = useState([]);

  const load = async () => {
    try {
      const [vr, cr, pr] = await Promise.all([
        api.get(`/vehicles/${id}`),
        api.get("/clients"),
        api.get(`/photos/by-vehicle/${id}`),
      ]);
      setV(vr.data); setClients(cr.data); setPhotos(pr.data);
    } catch (e) { toast.error(formatApiError(e)); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [id]);

  const save = async () => {
    try { await api.put(`/vehicles/${id}`, v); toast.success("Guardado"); }
    catch (e) { toast.error(formatApiError(e)); }
  };

  if (!v) return <div className="text-zinc-500">Cargando…</div>;

  return (
    <div data-testid="expediente-detail" className="space-y-8">
      <div className="flex items-center justify-between">
        <div>
          <button onClick={() => nav("/expedientes")} className="text-xs text-zinc-500 inline-flex items-center gap-1 hover:text-zinc-900 mb-2"><ArrowLeft size={12} /> Volver</button>
          <h1 className="section-title">Expediente <span className="font-mono text-xl ml-2">{v.plate}</span></h1>
          <p className="text-sm text-zinc-500 mt-1">{v.brand} {v.model} · {v.color || "—"}</p>
        </div>
        <Button onClick={save}><Save size={14} className="mr-1" />Guardar</Button>
      </div>

      <div className="page-card grid grid-cols-1 md:grid-cols-3 gap-4">
        <div><Label className="text-xs">Matrícula</Label><Input value={v.plate} onChange={(e) => setV({ ...v, plate: e.target.value.toUpperCase() })} /></div>
        <div><Label className="text-xs">VIN</Label><Input value={v.vin} onChange={(e) => setV({ ...v, vin: e.target.value.toUpperCase() })} /></div>
        <div><Label className="text-xs">Color</Label><Input value={v.color} onChange={(e) => setV({ ...v, color: e.target.value })} /></div>
        <div><Label className="text-xs">Marca</Label><Input value={v.brand || ""} onChange={(e) => setV({ ...v, brand: e.target.value })} /></div>
        <div><Label className="text-xs">Modelo</Label><Input value={v.model || ""} onChange={(e) => setV({ ...v, model: e.target.value })} /></div>
        <div>
          <Label className="text-xs">Cliente</Label>
          <Select value={v.client_id || "none"} onValueChange={(val) => setV({ ...v, client_id: val === "none" ? null : val })}>
            <SelectTrigger><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="none">— Sin cliente —</SelectItem>
              {clients.map(c => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div><Label className="text-xs">Aseguradora</Label><Input value={v.insurance || ""} onChange={(e) => setV({ ...v, insurance: e.target.value })} /></div>
        <div><Label className="text-xs">Perito</Label><Input value={v.expert || ""} onChange={(e) => setV({ ...v, expert: e.target.value })} /></div>
        <div></div>
        <div><Label className="text-xs">Fecha entrada</Label><Input type="date" value={v.entry_date || ""} onChange={(e) => setV({ ...v, entry_date: e.target.value })} /></div>
        <div><Label className="text-xs">Fecha prevista reparación</Label><Input type="date" value={v.repair_date || ""} onChange={(e) => setV({ ...v, repair_date: e.target.value })} /></div>
        <div></div>
        <div className="md:col-span-3"><Label className="text-xs">Observaciones</Label><Textarea rows={3} value={v.notes || ""} onChange={(e) => setV({ ...v, notes: e.target.value })} /></div>
      </div>

      <div className="page-card">
        <div className="text-xs uppercase tracking-wider text-zinc-500 mb-3">Fotos del expediente ({photos.length})</div>
        {photos.length === 0 ? (
          <div className="text-sm text-zinc-400 py-6 text-center">Las fotos se suben desde el presupuesto y se comparten automáticamente con la factura.</div>
        ) : (
          <div className="grid grid-cols-3 md:grid-cols-5 gap-3">
            {photos.map(p => (
              <img key={p.id} src={`${process.env.REACT_APP_BACKEND_URL}${p.url}`} className="w-full h-24 object-cover rounded border border-[var(--rule)]" alt="" />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
